"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.95817 2.56185C2.64567 2.89518 2.49984 3.31185 2.49984 3.89518C2.49984 4.37435 2.31234 5.20768 2.08317 5.74935C1.62484 6.79102 1.6665 7.62435 2.20817 8.47852C2.4165 8.81185 2.49984 10.0618 2.5415 13.5827L2.604 18.2285H9.99984H17.3957L17.4582 13.5827C17.4998 10.0618 17.5832 8.81185 17.7915 8.47852C18.3332 7.62435 18.3748 6.79102 17.9165 5.74935C17.6873 5.20768 17.4998 4.39518 17.4998 3.97852C17.4998 3.47852 17.3332 2.95768 17.0623 2.62435L16.6457 2.08268H10.0207H3.39567L2.95817 2.56185ZM16.2498 4.14518C16.2498 4.60352 16.4373 5.39518 16.6665 5.93685C17.1665 7.08268 17.0623 7.66602 16.229 8.45768C15.7082 8.95768 15.4165 9.06185 14.5832 9.06185C13.9165 9.06185 13.4582 8.93685 13.1873 8.68685C12.6665 8.22852 12.354 8.22852 11.354 8.74935C10.3332 9.27018 9.6665 9.27018 8.64567 8.74935C7.64567 8.22852 7.33317 8.22852 6.81234 8.68685C6.5415 8.93685 6.08317 9.06185 5.4165 9.06185C4.58317 9.06185 4.2915 8.95768 3.77067 8.45768C2.93734 7.66602 2.83317 7.08268 3.33317 5.93685C3.56234 5.39518 3.74984 4.60352 3.74984 4.14518V3.33268H9.99984H16.2498V4.14518ZM9.99984 10.416C10.3957 10.3952 11.104 10.2493 11.5415 10.041C12.3332 9.68685 12.3957 9.68685 13.104 10.041C13.9165 10.4577 14.8957 10.5202 15.7082 10.2077L16.2498 9.99935V13.541V17.0827H15.4165H14.604L14.5415 14.416L14.479 11.7702H11.6665H8.854L8.7915 14.416L8.729 17.0827H6.24984H3.74984V13.541V9.99935L4.2915 10.2077C5.08317 10.5202 6.06234 10.4577 6.87484 10.041C7.56234 9.68685 7.64567 9.68685 8.43734 10.041C8.89567 10.2493 9.604 10.416 9.99984 10.416ZM13.3332 14.9993V17.0827H11.6665H9.99984V14.9993V12.916H11.6665H13.3332V14.9993Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.7498 4.45826C11.5414 4.99993 11.8331 5.45826 12.3331 5.37493C12.6873 5.33326 12.8123 5.1666 12.8123 4.7916C12.8123 4.4166 12.6873 4.24993 12.3331 4.20826C12.0623 4.1666 11.8123 4.27076 11.7498 4.45826Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.8333 4.45826C13.6249 4.99993 13.9166 5.45826 14.4166 5.37493C14.7708 5.33326 14.8958 5.1666 14.8958 4.7916C14.8958 4.4166 14.7708 4.24993 14.4166 4.20826C14.1458 4.1666 13.8958 4.27076 13.8333 4.45826Z",
    fill: fill
  }));
};

exports["default"] = _default;